import * as constants from '../constants';

const tools = require('helpers/tools');

/** ACTION-CREATORS * */

export const actions = {
    getNurseDeploymentFixations: () => ({
        type: constants.GET_NURSE_DEPLOYMENT_FIXATIONS,
    }),
    addNurseDeploymentFixation: (prefill = {}) => {
        const nurseDeploymentFixation = Object.assign({}, emptyNurseDeploymentFixation, {
            ...prefill,
        });
        return {
            type: constants.ADD_NURSE_DEPLOYMENT_FIXATION,
            nurseDeploymentFixation,
        };
    },
    editNurseDeploymentFixation: (nurseDeploymentFixation) => ({
        type: constants.EDIT_NURSE_DEPLOYMENT_FIXATION,
        nurseDeploymentFixation,
    }),
    saveNurseDeploymentFixation: (nurseDeploymentFixation) => ({
        type: constants.SAVE_NURSE_DEPLOYMENT_FIXATION,
        nurseDeploymentFixation,
    }),
    deleteNurseDeploymentFixation: (nurseDeploymentFixation) => ({
        type: constants.DELETE_NURSE_DEPLOYMENT_FIXATION,
        nurseDeploymentFixation,
    }),
};

const emptyNurseDeploymentFixation = {
    employeeId: '',
    agencyId: '',
    locationId: '',
    fixedAt: '',
    createdAt: '',
    updatedAt: '',
    id: '',
};

/** STATE & MUTATIONS * */
export default function nurseDeploymentFixationReducer(
    state = {
        nurseDeploymentFixations: [],
        editItem: null,
        loading: false,
        loadError: false,
        saving: false,
        saveSuccess: false,
        saveError: false,
        deleting: false,
        deleteError: false,
        deleteSuccess: false,
    },
    action
) {
    switch (action.type) {
        case constants.GET_NURSE_DEPLOYMENT_FIXATIONS:
            return tools.update(state, {
                nurseDeploymentFixations: [],
                loading: true,
                loadError: false,
                saveSuccess: false,
                saveError: false,
            });

        case constants.GET_NURSE_DEPLOYMENT_FIXATIONS_ERROR:
            return tools.update(state, {
                nurseDeploymentFixations: [],
                loading: false,
                loadError: action.err,
            });

        case constants.GET_NURSE_DEPLOYMENT_FIXATIONS_SUCCESS:
            return tools.update(state, {
                nurseDeploymentFixations: action.data,
                loading: false,
                loadError: false,
            });

        case constants.ADD_NURSE_DEPLOYMENT_FIXATION:
        case constants.EDIT_NURSE_DEPLOYMENT_FIXATION:
            return tools.update(state, {
                editItem: action.nurseDeploymentFixation,
            });

        case constants.EDIT_NURSE_DEPLOYMENT_FIXATION_CANCEL:
            return tools.update(state, {
                editItem: null,
                saveSuccess: false,
                saveError: false,
                saving: false,
            });

        case constants.SAVE_NURSE_DEPLOYMENT_FIXATION:
            return tools.update(state, {
                saving: true,
                saveError: false,
                saveSuccess: false,
            });

        case constants.POST_NURSE_DEPLOYMENT_FIXATION_ERROR:
        case constants.PUT_NURSE_DEPLOYMENT_FIXATION_ERROR:
            return tools.update(state, {
                saving: false,
                saveError: action.err,
                saveSuccess: false,
            });

        case constants.POST_NURSE_DEPLOYMENT_FIXATION_SUCCESS:
            return tools.update(state, {
                saving: false,
                saveError: false,
                saveSuccess: true,
                nurseDeploymentFixations: [...state.nurseDeploymentFixations, action.data.nurseDeploymentFixation],
            });

        case constants.PUT_NURSE_DEPLOYMENT_FIXATION_SUCCESS:
            return {
                ...state,
                saving: false,
                saveError: false,
                saveSuccess: true,
                nurseDeploymentFixations: state.nurseDeploymentFixations.map((nurseDeploymentFixation) =>
                    nurseDeploymentFixation.id === action.data.nurseDeploymentFixation.id ? action.data.nurseDeploymentFixation : nurseDeploymentFixation
                ),
            };

        case constants.DELETE_NURSE_DEPLOYMENT_FIXATION_SUCCESS:
            // Remove deleted item from store
            return tools.update(state, {
                nurseDeploymentFixations: tools.removeItemByProp(state.nurseDeploymentFixations, 'id', action.data.id),
                deleteError: false,
                deleteSuccess: true,
            });

        default:
            return state;
    }
}
